var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","align-center":""}},[(_vm.isLoginFormShow)?_c('ComponentLogin',{on:{"showRegister":_vm.isShowRegister,"getUsername":_vm.getUsername}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }